import React from 'react';
import { Box, Typography } from '@mui/material';
import { Pause, PlayArrow, Stop } from '@mui/icons-material';
import Button from './Button';
import { COLOR, RADIUS } from './tokens';

/**
 * Start / Pause / End bar driven by the play phase. A finished or manually
 * ended run offers Play Again. `endLabel` lets a game keep its own wording.
 */
export default function GameControls({
    phase,
    onStart,
    onPause,
    onEnd,
    showPause = true,
    endLabel = 'End Game',
    readyText = 'Ready to play?',
    disabled = false,
    sx,
}) {
    let content;
    if (phase === 'menu') {
        content = <Typography sx={{ color: COLOR.textMuted }}>{readyText}</Typography>;
    } else if (phase === 'over' || phase === 'ended') {
        content = (
            <Button onClick={onStart} startIcon={<PlayArrow />} disabled={disabled}>
                Play Again
            </Button>
        );
    } else {
        content = (
            <>
                {showPause ? (
                    <Button
                        variant="secondary"
                        onClick={onPause}
                        startIcon={phase === 'playing' ? <Pause /> : <PlayArrow />}
                    >
                        {phase === 'playing' ? 'Pause' : 'Resume'}
                    </Button>
                ) : null}
                <Button variant="danger" onClick={onEnd} startIcon={<Stop />}>
                    {endLabel}
                </Button>
            </>
        );
    }
    return (
        <Box
            data-testid="game-controls"
            sx={[
                {
                    mt: 2,
                    p: 2,
                    bgcolor: COLOR.surface,
                    border: `1px solid ${COLOR.border}`,
                    borderRadius: RADIUS.lg,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: 'wrap',
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {content}
        </Box>
    );
}
